/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Auto_Correct_Failed_ToastInputs */

const en_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to auto correct events based on reading rate`)
};

const fr_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de l'auto-correction des evenements selon la vitesse de lecture`)
};

const de_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Korrektur von Ereignissen basierend auf der Lesegeschwindigkeit ist fehlgeschlagen.`)
};

const it_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile correggere automaticamente gli eventi in base alla velocità di lettura`)
};

const ru_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось автоматически скорректировать события на основе скорости чтения.`)
};

const es_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron corregir automáticamente los eventos según la velocidad de lectura`)
};

const zh_cn2_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据阅读速率自动更正事件失败`)
};

const ja_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り速度に基づいてイベントを自動修正できませんでした`)
};

const hi_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पठन दर के आधार पर घटनाओं को स्वतः ठीक करने में विफलता`)
};

const pt_pt2_iframe_remote_auto_correct_failed_toast = /** @type {(inputs: Iframe_Remote_Auto_Correct_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na correção automática de eventos com base na taxa de leitura.`)
};

/**
* | output |
* | --- |
* | "Failed to auto correct events based on reading rate" |
*
* @param {Iframe_Remote_Auto_Correct_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_auto_correct_failed_toast = /** @type {((inputs?: Iframe_Remote_Auto_Correct_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Auto_Correct_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "de") return de_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "it") return it_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "es") return es_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_auto_correct_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_auto_correct_failed_toast(inputs)
	return en_iframe_remote_auto_correct_failed_toast(inputs)
});